// extracted by mini-css-extract-plugin
export default {"Container":"IconList_Container__OhyvV","IconContainer":"IconList_IconContainer__Q+Q+I","Icon":"IconList_Icon__-kzBZ"};